class ProductPrice extends HTMLElement {
  constructor() {
    super();

    this.regural = this.querySelector('[data-regural]');
    this.compare = this.querySelector('[data-compare]');
    this.savingsWrap = this.querySelector('[data-savings-wrap]');
    this.saving = this.querySelector('[data-saving]');
    this.discountLength = this.querySelector('[data-length]');
    this.subtotalWrap = this.querySelector('[data-subtotal-wrap]');
    this.subtotal = this.querySelector('[data-subtotal]');
    this.subtotalCompare = this.querySelector('[data-subtotal-compare]');
    this.firstMonthOffer = this.querySelector('[data-first-month-offer]');
    document.body.addEventListener('variant:change', this.handleVariantChange.bind(this));
    document.body.addEventListener('discount:change', this.handleDiscountChange.bind(this));

    const productForm = document.querySelector('product-form');
    if (productForm && productForm.selectedVariant) {
      this.variant = productForm.selectedVariant;
      this.updatePrice();
    }
  }

  handleDiscountChange(event) {
    this.discount = event.detail;
    this.updatePrice();
  }

  handleVariantChange(event) {
    this.variant = event.detail.variant;
    this.updatePrice();
  }

  formatPrice(value) {
    if (!value || value === 0) return '';

    const formated = value.toFixed(2);
    return `$${formated.replace('.00', '')}`;
  }

  getDiscountLength() {
    if (!this.discount) {
      return;
    }

    const value = this.discount?.recurringCycleLimit;

    if (!value) {
      return 'Lifetime Deal!';
    }

    if (value === 1) {
      return 'First Month';
    }

    return `${value} Months`;
  }

  updatePrice() {
    if (!this.variant) return;

    console.log(this.variant);

    const { priceValue, comparePriceValue, pricePerMonthValue, comparePricePerMonthValue, billingMonths } =
      this.variant;

    const isDiscountApplied =
      this.discount &&
      (this.discount.products.includes(this.variant.productId) || this.discount.variants.includes(this.variant.id));

    let monthlyPrice = pricePerMonthValue;
    let monthlyPriceCompare = comparePricePerMonthValue;
    let subtotal = priceValue;
    let subtotalCompare = comparePriceValue;
    let savingText = '';
    let discountLength = '';

    if (isDiscountApplied) {
      if (this.discount.amount) {
        savingText = this.formatPrice(this.discount.amount) + ' OFF';
        subtotal = subtotal - this.discount.amount;

        if (billingMonths > 1) {
          monthlyPrice = monthlyPrice - this.discount.amount / billingMonths;
        } else {
          monthlyPrice = monthlyPrice - this.discount.amount;
        }
      } else if (this.discount.percentage) {
        savingText = this.discount.percentage * 100 + '% OFF';
        monthlyPrice = monthlyPrice * (1 - this.discount.percentage);
        subtotal = subtotal * (1 - this.discount.percentage);
      }
      discountLength = this.getDiscountLength();
    }

    // Savings
    if (this.savingsWrap) {
      this.savingsWrap.classList.toggle('hidden', !isDiscountApplied);
    }

    if (this.saving) this.saving.innerHTML = savingText;
    if (this.discountLength) this.discountLength.innerHTML = discountLength;

    // Monthly
    if (this.regural) this.regural.innerHTML = this.formatPrice(monthlyPrice) + '/mo';
    if (this.compare)
      this.compare.innerHTML = monthlyPriceCompare > monthlyPrice ? this.formatPrice(monthlyPriceCompare) : '';

    // Subtotal
    if (this.subtotalWrap) {
      this.subtotalWrap.classList.toggle('hidden', billingMonths === 1);
    }

    // First Month Offer
    if (this.firstMonthOffer) {
      console.log(this.variant);
      this.firstMonthOffer.classList.toggle('hidden', this.variant.offer !== 'first_month_offer');
      if (this.variant.offer === 'first_month_offer') {
        if (this.regural) this.regural.innerHTML = this.formatPrice(this.variant.offerOriginalValue) + '/mo';
      }
    }

    if (this.subtotal) this.subtotal.innerHTML = this.formatPrice(subtotal);
    if (this.subtotalCompare)
      this.subtotalCompare.innerHTML = subtotalCompare > subtotal ? this.formatPrice(subtotalCompare) : '';
  }
}

customElements.define('product-price', ProductPrice);
